<template>
  <div>
    <span v-if="remainingTime > 0">{{ formattedTime }}</span>
    <span v-else>{{ $t(endText) }}</span>
  </div>
</template>

<script>
export default {
  props: {
    duration: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      remainingTime: this.duration,
      timer: null
    };
  },
  computed: {
    formattedTime() {
      const days = Math.floor(this.remainingTime / 86400);
      const hours = Math.floor((this.remainingTime % 86400) / 3600);
      const minutes = Math.floor((this.remainingTime % 3600) / 60);
      const seconds = this.remainingTime % 60;
      const pad = (num) => String(num).padStart(2, '0');

      return `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }
  },
  methods: {
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    }
  },
  mounted() {
    this.startCountdown();
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
};
</script>
